// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { FacilityEventType } from "./Shared.FacilityEventType.gen";
import { TargetType } from "./Shared.TargetType.gen";

export interface IDriverEvent {
	id: string | undefined;

	dateCreated: string | undefined;

	eventType: FacilityEventType;

	name: string | undefined;

	zoneName: string | undefined;

	velocity: number | undefined;

	targetType: TargetType | undefined;

	clipAccessToken: string | undefined;

	clipRequestId: string | undefined;

	hasClipVideo: boolean;

	attachmentUrl: string | undefined;

	$type?: string | undefined;
}
export class DriverEvent {
	constructor(data?: IDriverEvent) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
	}

	id: string | undefined;

	dateCreated: Date | undefined = new Date();

	eventType: FacilityEventType = 0;

	name: string | undefined;

	zoneName: string | undefined;

	velocity: number | undefined;

	targetType: TargetType | undefined;

	clipAccessToken: string | undefined;

	clipRequestId: string | undefined;

	hasClipVideo: boolean = false;

	attachmentUrl: string | undefined;

	static $type: string = "CoreApi.Models.DriverEvent, ";
	$type?: string | undefined = DriverEvent.$type;
}

